import {
  useState,
  useRef,
  Fragment,
  useCallback,
  useEffect,
  ChangeEvent,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HotelDetail from "../../components/Hotel/HotelDetail";
import {
  ResponseFailModal,
  ResponseSuccessModal,
} from "../../components/Modal/Response";
import { RootState } from "../../stores";
import {
  changeField,
  changeResult,
  selectHotelAction,
  updateHotelAction,
  listCommonRoomAction,
} from "../../stores/hotel";
import { listNotifyChannelListAction } from "../../stores/notifyChannelList";
import { changeProps } from "../../types/commons";
import { checkProps, HotelDetailContainerProps } from "../../types/hotel";
import HotelDeleteContainer from "./HotelDeleteContainer";
import HotelCommonroomUpdateContainer from "./HotelCommonroomUpdateContainer";

const HotelDetailContainer = ({ isOpen }: HotelDetailContainerProps) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const {
    hotelItem,
    hotelSuccess,
    hotelError,
    notifyChannelListItems,
    commonRooms,
  } = useSelector(({ hotel, notifyChannelList }: RootState) => ({
    hotelItem: hotel.hotel,
    hotelSuccess: hotel.hotelUpdateSuccess,
    hotelError: hotel.hotelUpdateError,
    notifyChannelListItems: notifyChannelList.notifyChannelListItems,
    commonRooms: hotel.commonRooms,
  }));
  const commonroomInputRef = useRef<any | null>(null);
  const [isOpenHotelDeleteModal, setIsOpenHotelDeleteModal] =
    useState<boolean>(false);
  const [isOpenHotelUpdateModal, setIsOpenHotelUpdateSuccessModal] =
    useState<boolean>(false);
  const [isOpenHotelUpdateFailModal, setIsOpenHotelUpdateFailModal] =
    useState<boolean>(false);
  const [
    isOpenRequiredParameterFailModal,
    setIsOpenRequiredParameterFailModal,
  ] = useState<boolean>(false);
  const [messageHotelUpdateFail, setMessageHotelUpdateFail] =
    useState<string>("");
  const [editableCommonroom, setEditableCommonroom] = useState<number | null>(
    null,
  );
  const [detailCommonroom, setDetailCommonroom] = useState<string | null>(null);
  const [isOpenCommonroomModal, setIsOpenCommonrommModal] =
    useState<boolean>(false);

  const [detailCommonroomItem, setDetailCommonroomItem] = useState<any>();

  //인풋 변경 이벤트 핸들러
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
      const { value, name } = e.target;
      const value2 =
        name === "useSlimkey" ||
        name === "allowInfinityPincode" ||
        name === "apphotelstory" ||
        name === "appElevatorBtn" ||
        name === "doorlockDeletable"
          ? value === "O"
            ? true
            : false
          : value;
      dispatch(
        changeField({
          key: name,
          value: value2,
        }),
      );
    },
    [dispatch],
  );

  const handleAddCommonroom = () => {
    if (!commonroomInputRef.current.value) return;
    const commonrooms = [...hotelItem.commonrooms];
    commonrooms.push({ name: commonroomInputRef.current.value });
    commonroomInputRef.current.value = null;
    dispatch(
      changeField({
        key: "commonrooms",
        value: commonrooms,
      }),
    );
  };

  const handleChangeCommonroom = ({ id, name }: changeProps) => {
    const commonrooms = hotelItem.commonrooms.map(
      (commonroom: any, index: number) => {
        const new_name = { ...commonroom };
        if (commonroom.id) {
          if (commonroom.id === id) new_name.name = name;
        } else {
          if (index === id) new_name.name = name;
        }
        return new_name;
      },
    );
    dispatch(
      changeField({
        key: "commonrooms",
        value: commonrooms,
      }),
    );
  };

  const handleRemoveCommonroom = (index: number) => {
    const commonrooms = [...hotelItem.commonrooms];
    commonrooms.splice(index, 1);
    dispatch(
      changeField({
        key: "commonrooms",
        value: commonrooms,
      }),
    );
  };

  const handleEditableCommonroom = (index: number) => {
    setEditableCommonroom(index);
  };

  const handleDetailCommonroom = (id: string) => {
    setDetailCommonroom(id);
    handleSelectCommonRoom();
  };

  const handleListNotifyChannel = useCallback(() => {
    dispatch(listNotifyChannelListAction({}));
  }, [dispatch]);

  const handleSelectHotel = useCallback(() => {
    dispatch(selectHotelAction());
  }, [dispatch]);

  const handleSelectCommonRoom = useCallback(() => {
    dispatch(listCommonRoomAction());
  }, [dispatch]);

  useEffect(() => {
    if (detailCommonroom && commonRooms.length > 0) {
      const selectedRoom = commonRooms.find(
        (room) => room.id.toString() === detailCommonroom,
      );
      if (selectedRoom) {
        setIsOpenCommonrommModal(true);
        setDetailCommonroomItem(selectedRoom);
      }
    }
  }, [detailCommonroom, commonRooms]);

  //체크용
  const validateUpdateHotelItem = ({ name, timezone }: checkProps) => {
    return name && timezone;
  };

  const handleUpdateHotel = useCallback(() => {
    if (
      !validateUpdateHotelItem({
        name: hotelItem.name,
        timezone: hotelItem.timezone,
      })
    ) {
      setIsOpenRequiredParameterFailModal(true);
      return;
    }
    dispatch(
      updateHotelAction({
        ...hotelItem,
        notifyEmail: hotelItem.notifyEmail ? hotelItem.notifyEmail : null,
      }),
    );
  }, [dispatch, hotelItem]);

  const handleHotelDeleteModal = () => {
    //if (hotelListTotal === 1) return;
    setIsOpenHotelDeleteModal(true);
  };

  const handleReload = () => {
    navigation("/hotel");
  };

  useEffect(() => {
    if (hotelError) {
      if (!hotelError.response) setMessageHotelUpdateFail(hotelError.message);
      else
        setMessageHotelUpdateFail(
          `${hotelError.response.data.code}, ${hotelError.response.data.message}`,
        );
      setIsOpenHotelUpdateFailModal(true);
      dispatch(
        changeResult({
          key: "hotelUpdateError",
          value: null,
        }),
      );
      return;
    }
    if (hotelSuccess) {
      setIsOpenHotelUpdateSuccessModal(true);
      setTimeout(() => {
        setIsOpenHotelUpdateSuccessModal(false);
        handleSelectHotel();
        handleSelectCommonRoom();
      }, 1500);
      dispatch(
        changeResult({
          key: "hotelUpdateSuccess",
          value: false,
        }),
      );
    }
  }, [
    hotelSuccess,
    hotelError,
    dispatch,
    handleSelectHotel,
    handleSelectCommonRoom,
  ]);

  useEffect(() => {
    if (isOpen) {
      handleListNotifyChannel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Fragment>
      <HotelDetail
        hotelItem={hotelItem}
        commonroomInputRef={commonroomInputRef}
        editableCommonroom={editableCommonroom}
        notifyChannelListItems={notifyChannelListItems}
        detailCommonroom={detailCommonroom}
        handleHotelDeleteModal={handleHotelDeleteModal}
        handleChange={handleChange}
        handleAddCommonroom={handleAddCommonroom}
        handleRemoveCommonroom={handleRemoveCommonroom}
        handleEditableCommonroom={handleEditableCommonroom}
        handleChangeCommonroom={handleChangeCommonroom}
        handleSelectHotel={handleSelectHotel}
        handleUpdateHotel={handleUpdateHotel}
        handleDetailCommonroom={handleDetailCommonroom}
      />
      <HotelCommonroomUpdateContainer
        detailCommonroomItem={detailCommonroomItem}
        isOpen={isOpenCommonroomModal}
        toggle={() => setIsOpenCommonrommModal(!isOpenCommonroomModal)}
      />

      <HotelDeleteContainer
        isOpen={isOpenHotelDeleteModal}
        toggle={() => setIsOpenHotelDeleteModal(!isOpenHotelDeleteModal)}
        reload={handleReload}
        hotelName={hotelItem.name}
      />
      <ResponseSuccessModal
        isOpen={isOpenHotelUpdateModal}
        toggle={() => setIsOpenHotelUpdateSuccessModal(!isOpenHotelUpdateModal)}
        message="단지 정보 수정이 완료 되었습니다."
      />
      <ResponseFailModal
        isOpen={isOpenHotelUpdateFailModal}
        toggle={() =>
          setIsOpenHotelUpdateFailModal(!isOpenHotelUpdateFailModal)
        }
        message={messageHotelUpdateFail || "단지 정보 수정에 실패 하였습니다."}
      />
      <ResponseFailModal
        isOpen={isOpenRequiredParameterFailModal}
        toggle={() =>
          setIsOpenRequiredParameterFailModal(!isOpenRequiredParameterFailModal)
        }
        message="필수 입력값을 확인 해주세요."
      />
    </Fragment>
  );
};

export default HotelDetailContainer;
